import suncoastLogo from '@/assets/images/suncoast-logo.png'
import ozarkLogo from '@/assets/images/ozark-logo.png'
import rrvbcLogo from '@/assets/images/rrvbc-logo.png'
import absLogo from '@/assets/images/abs-logo.png'
import kbcLogo from '@/assets/images/kbc-logo.png'
import lifeserveLogo from '@/assets/images/lifeserve-logo.png'

export const TENANTS = {
  SUNCOAST: 'suncoast',
  OZARK: 'ozark',
  RRVBC: 'rrvbc',
  ABS: 'abs',
  KBC: 'kbc',
  LIFESERVE: 'lifeserve',
}

export const TENANT_COLORS = {
  [TENANTS.SUNCOAST]: {
    primary: '#00ae9b',
  },
  [TENANTS.RRVBC]: {
    primary: '#b5121b',
  },
  [TENANTS.OZARK]: {
    primary: '#5298d2',
  },
  [TENANTS.ABS]: {
    primary: '#423058',
  },
  [TENANTS.KBC]: {
    primary: '#8c2b86',
  },
  [TENANTS.LIFESERVE]: {
    primary: '#005596',
  },
}

export const TENANT_TOPBAR_CONFIGS = {
  [TENANTS.SUNCOAST]: {
    logo: {
      href: 'https://suncoastblood.org',
      src: suncoastLogo,
      alt: 'SunCoast Blood Centers',
      maxWidth: 180,
      fallbackText: 'SunCoast',
    },
    menus: [
      { title: 'Home', url: 'https://suncoastblood.org' },
      {
        title: 'Donate',
        url: 'https://suncoastblood.org/donate/locations/',
        links: [
          {
            title: 'Donation Location',
            url: 'https://suncoastblood.org/donate/locations/',
          },
          {
            title: 'Eligibility To Donate',
            url: 'https://suncoastblood.org/donate/faqs/',
          },
          {
            title: 'Types of Donations',
            url: 'https://suncoastblood.org/donate/types-of-donations/',
          },
          {
            title: 'QuickPass',
            url: 'https://suncoastblood.org/donate/quickpass/',
          },
          {
            title: 'Appointment Portal',
            url: 'https://donorportal.suncoastblood.org/',
          },
        ],
      },
      { title: 'Research', url: 'https://suncoastblood.org/research/' },
      {
        title: 'Ways To Help',
        url: 'https://suncoastblood.org/get-involved/',
        links: [
          {
            title: 'Become A Sponsor',
            url: 'https://suncoastblood.org/get-involved/become-a-sponsor/',
          },
          {
            title: 'Host A Blood Drive',
            url: 'https://suncoastblood.org/get-involved/host-a-blood-drive/',
          },
          {
            title: 'Make a Financial Gift',
            url: 'https://suncoastblood.org/get-involved/donate/',
          },
          {
            title: 'Student Resources',
            url: 'https://suncoastblood.org/students/',
          },
          {
            title: 'Volunteer',
            url: 'https://suncoastblood.org/get-involved/volunteer/',
          },
        ],
      },
      {
        title: 'About Us',
        url: 'https://suncoastblood.org/about/',
        links: [
          {
            title: 'Accreditations',
            url: 'https://suncoastblood.org/about/accreditations/',
          },
          { title: 'Blog', url: 'https://suncoastblood.org/blog/' },
          { title: 'Events', url: 'https://suncoastblood.org/events/' },
          {
            title: 'Leadership Team',
            url: 'https://suncoastblood.org/about/leadership/',
          },
          { title: 'Our History', url: 'https://suncoastblood.org/about/' },
          {
            title: 'Supporting Our Troops',
            url: 'https://suncoastblood.org/about/supporting-our-troops/',
          },
          {
            title: 'Who We Serve',
            url: 'https://suncoastblood.org/about/who-we-serve/',
          },
        ],
      },
      {
        title: 'QuickPass',
        url: 'https://suncoastblood.org/donate/quickpass/',
      },
    ],
    actionsGuest: [
      { title: 'Sign In', href: '/login' },
      { title: 'Sign Up', href: '/register' },
    ],
  },
  [TENANTS.OZARK]: {
    logo: {
      href: 'https://cbco.org',
      src: ozarkLogo,
      alt: 'Community Blood Center of the Ozarks',
      maxWidth: 190,
      fallbackText: 'OZARK',
    },
    menus: [
      {
        title: 'About',
        url: 'https://www.cbco.org/about-us/',
        links: [
          {
            title: 'From the ED',
            url: 'https://www.cbco.org/about-us/executive-director/',
          },
          {
            title: 'Who We Are',
            url: 'https://www.cbco.org/about-us/who-we-are/',
          },
          {
            title: 'Service Area',
            url: 'https://www.cbco.org/about-us/service-area/',
          },
          {
            title: 'Career Opportunities',
            url: 'https://www.cbco.org/about-us/career-opportunities/',
          },
          {
            title: 'Hospital Resources',
            url: 'https://www.cbco.org/about-us/hospital-resources/',
          },
          {
            title: 'Contact Us',
            url: 'https://www.cbco.org/about-us/contact-us/',
          },
        ],
      },
      {
        title: 'Donate',
        url: 'https://www.cbco.org/donate-blood',
        links: [
          {
            title: 'Center Hours',
            url: 'https://www.cbco.org/community-blood-center-locations-and-hours/',
          },
          { title: 'Can I Give?', url: 'https://www.cbco.org/can-i-give/' },
          {
            title: 'Blood types',
            url: 'https://www.cbco.org/whats-in-a-type/',
          },
          { title: 'Donation Types', url: 'https://www.cbco.org/blood-101/' },
          {
            title: 'What to Expect',
            url: 'https://www.cbco.org/donation-101/',
          },
          {
            title: 'Iron and Hemoglobin',
            url: 'https://www.cbco.org/donate-blood/iron-faq/',
          },
          { title: 'Donor QuickPass', url: 'https://www.cbco.org/quickpass/' },
          {
            title: 'QuickPass FAQ',
            url: 'https://www.cbco.org/quickpass/quickpass-faq/',
          },
        ],
      },
      {
        title: 'Students',
        url: 'https://www.cbco.org/high-schools/',
        links: [
          {
            title: 'Parental Consent',
            url: 'https://www.cbco.org/lc-content/uploads/QuickPass/DRS.04.F036.pdf',
          },
          {
            title: 'Throwdown Showdown!',
            url: 'https://www.cbco.org/high-school-throwdown-showdown/',
          },
          {
            title: 'Leadership Workshop',
            url: 'https://www.cbco.org/workshop/',
          },
        ],
      },
      {
        title: 'Info',
        links: [
          {
            title: 'Thank the Donor®',
            url: 'https://www.cbco.org/thankthedonor/',
          },
          {
            title: 'LifePoints FAQ',
            url: 'https://www.cbco.org/lifepoints-frequently-asked-questions/',
          },
          { title: 'Stories', url: 'https://www.cbco.org/stories-2/' },
          {
            title: 'Contact Us',
            url: 'https://www.cbco.org/about-us/contact-us/',
          },
        ],
      },
      {
        title: 'Schedule Donation',
        url: '/schedule-donation',
        links: [],
      },
    ],
    actions: [
      { title: 'Donate Blood', href: 'https://www.cbco.org/donate-blood/' },
      { title: 'Host a Drive', href: 'https://www.cbco.org/host-a-drive/' },
    ],
    actionsGuest: [{ title: 'Donor Sign-in', href: '/login' }],
  },
  [TENANTS.RRVBC]: {
    preHeader: {
      text: 'Call us at 815-965-8751  |  contactus@rrvbc.org',
      socials: [
        {
          title: 'Facebook',
          url: 'https://www.facebook.com/rockrivervalleybloodcenter',
        },
        { title: 'X', url: 'https://twitter.com/RRVBC' },
        { title: 'YouTube', url: 'https://www.youtube.com/user/BulaBlood' },
      ],
    },
    logo: {
      href: 'https://rrvbc.org',
      src: rrvbcLogo,
      alt: 'Rock River Valley Blood Center',
      maxWidth: 208,
      fallbackText: 'RRVBC',
    },
    menus: [
      {
        title: 'Donate',
        url: 'https://www.rrvbc.org/donate/',
        submenuVariant: 'mega',
        submenuTitle: 'Show some love. Donate today!',
        submenuImage: {
          src: 'https://www.rrvbc.org/wp-content/uploads/2023/10/RRVBC-Donate-Placeholder.jpg',
          alt: 'Donate Today',
        },
        links: [
          { title: 'My Donations', url: 'https://www.rrvbc.org/app/' },
          { title: 'Schedule a Donation', url: 'https://www.rrvbc.org/app/' },
          { title: 'The Process', url: 'https://www.rrvbc.org/donate/#tour' },
          {
            title: 'Types of Donations',
            url: 'https://www.rrvbc.org/donate/#donationtypes',
          },
          {
            title: 'Donor Eligibility',
            url: 'https://www.rrvbc.org/donate/#Eligibility',
          },
          {
            title: 'Donor Center Locations',
            url: 'https://www.rrvbc.org/donor-center-locations/',
          },
          { title: 'Blood Drives', url: 'https://www.rrvbc.org/blood-drives/' },
        ],
      },
      {
        title: 'Make a Difference',
        links: [
          {
            title: 'Make a Financial Gift',
            url: 'https://www.rrvbc.org/make-financial-gift/',
          },
          {
            title: 'Organize a Drive',
            url: 'https://www.rrvbc.org/organize-drive/',
          },
          {
            title: 'Student Scholarship Drives',
            url: 'https://www.rrvbc.org/wp-content/uploads/2024/11/RRVBC-Scholarship-Poster.jpg',
          },
          {
            title: 'Sixteen-Year-Old Consent',
            url: 'https://www.rrvbc.org/wp-content/uploads/2024/11/Sixteen-Year-Old-Consent.pdf',
          },
          {
            title: 'Consent (Spanish)',
            url: 'https://www.rrvbc.org/wp-content/uploads/2024/12/16-Yr-Old-Consent-Spanish.pdf',
          },
          {
            title: 'Tell Us Your Story',
            url: 'https://www.rrvbc.org/tell-us-your-story/',
          },
        ],
        submenuVariant: 'mega',
        submenuImage: {
          src: 'https://www.rrvbc.org/wp-content/uploads/2023/10/RRVBC-Make-a-Difference.jpg',
          alt: 'Make a Difference',
        },
      },
      { title: 'Careers', url: 'https://www.rrvbc.org/careers/' },
      {
        title: 'About Us',
        url: 'https://www.rrvbc.org/about-us/',
        submenuVariant: 'mega',
        submenuImage: {
          src: 'https://www.rrvbc.org/wp-content/uploads/2022/09/blood-bus.png',
          alt: 'Blood Bus',
        },
        links: [
          { title: 'Contact Us', url: 'https://www.rrvbc.org/contact/' },
          { title: 'History', url: 'https://www.rrvbc.org/history/' },
          { title: 'Links', url: 'https://www.rrvbc.org/links/' },
          { title: 'Blood Facts', url: 'https://www.rrvbc.org/blood-facts-2/' },
          {
            title: 'Hospital Documents',
            url: 'https://www.rrvbc.org/hospitals/',
          },
        ],
      },
      { title: 'News', url: 'https://www.rrvbc.org/news' },
    ],
    trailing: [
      {
        title: 'Fund the Bus',
        url: 'https://www.rrvbc.org/fund-the-bus/',
      },
    ],
  },
  [TENANTS.ABS]: {
    logo: {
      href: 'https://www.atlantabloodservices.com/',
      src: absLogo,
      alt: 'Atlanta Blood Services',
      maxWidth: 180,
      fallbackText: 'ABS',
    },
  },
  [TENANTS.KBC]: {
    logo: {
      href: 'https://www.kybloodcenter.org/',
      src: kbcLogo,
      alt: 'Kentucky Blood Center',
      maxWidth: 180,
      fallbackText: 'KBC',
    },
  },
  [TENANTS.LIFESERVE]: {
    logo: {
      href: 'https://www.lifeservebloodcenter.org/',
      src: lifeserveLogo,
      alt: 'LifeServe Blood Center',
      maxWidth: 180,
      fallbackText: 'LifeServe',
    },
  },
}
